















import { Component, Prop, Vue } from 'vue-property-decorator'
import { GuestState } from '@/services/Guests'
import marked from 'marked'
import { linkRenderer } from '@/utils/Markdown'

@Component
export default class WaiterVideoStream extends Vue {
  @Prop({ required: true }) public waiterStreamClass!: string
  @Prop({ required: true }) public waiterVideoId!: string
  @Prop({ required: true }) public waiterName!: string
  @Prop({ required: true }) public waiterMessage!: string
  @Prop({ required: true }) public isSwitchingRoom!: boolean
  @Prop({ required: true }) public state!: GuestState

  get isInService() {
    return this.state === GuestState.Service
  }

  public markThis(txt: string) {
    marked.setOptions({
      renderer: linkRenderer,
    })
    return marked(txt)
  }
}
